import { useStore } from "ra-core";

export const BC_ENVIRONMENTS = [
  {
    code: "DK",
    label: "Gobo DK",
    companyId: "51ba846c-0cf6-ec11-82f8-000d3ab308be",
  },
  {
    code: "SE",
    label: "Gobo AB",
    companyId: "2e0a44c0-dddf-ec11-82f8-000d3ab909ed",
  },
] as const;

export type BcEnvironmentCode = (typeof BC_ENVIRONMENTS)[number]["code"];

export const DEFAULT_BC_ENVIRONMENT: BcEnvironmentCode = "DK";

export const BC_ENVIRONMENT_STORE_KEY = "crm.bcEnvironment";

export function isBcEnvironmentCode(
  value: unknown,
): value is BcEnvironmentCode {
  return (
    typeof value === "string" &&
    BC_ENVIRONMENTS.some((env) => env.code === value)
  );
}

export function getBcEnvironmentMeta(code: BcEnvironmentCode) {
  return BC_ENVIRONMENTS.find((env) => env.code === code) ?? BC_ENVIRONMENTS[0];
}

/** Current main BC environment preference (defaults to DK). */
export function useBcEnvironment(): BcEnvironmentCode {
  const [value] = useStore<string>(
    BC_ENVIRONMENT_STORE_KEY,
    DEFAULT_BC_ENVIRONMENT,
  );
  return isBcEnvironmentCode(value) ? value : DEFAULT_BC_ENVIRONMENT;
}
